import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // We log the error, usually to an external service.
    console.error("ErrorBoundary caught an error from Code Splitting or Component Crash", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center bg-gray-100">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Oops! Something went wrong.</h1>
          <p className="text-gray-600 mb-6 max-w-md">
            We couldn't load the underlying screen. This usually happens if there is a spotty network connection, or if we just pushed a new update!
          </p>
          <button 
            onClick={() => window.location.reload()}
            className="px-6 py-2 bg-yellow-600 text-white rounded shadow hover:bg-yellow-700 transition"
          >
            Refresh Configuration
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
